var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUnattended({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.5H14.5V13.75H19.5V12.5Z",
    fill: "#BB4D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15H14.5V16.25H19.5V15Z",
    fill: "#BB4D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.5H14.5V18.75H19.5V17.5Z",
    fill: "#BB4D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 15H12V16.25H13.25V15Z",
    fill: "#BB4D00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 12.5H12V13.75H13.25V12.5Z",
    fill: "#BB4D00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 17.5H12V18.75H13.25V17.5Z",
    fill: "#BB4D00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00931 5.18312C5.57257 4.51497 6.24758 3.9497 7.00425 3.5125L6.37994 2.43125C5.49714 2.94122 4.70964 3.60067 4.05256 4.38019L5.00931 5.18312Z",
    fill: "#BB4D00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4907 5.18312L17.4474 4.38019C16.7904 3.60067 16.0029 2.94122 15.1201 2.43125L14.4957 3.5125C15.2524 3.9497 15.9274 4.51497 16.4907 5.18312Z",
    fill: "#BB4D00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71037 7.4375L2.53712 7.01056C2.18395 7.96778 2.00213 8.97971 2 10H3.25C3.25182 9.12543 3.40766 8.25801 3.71037 7.4375Z",
    fill: "#BB4D00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00931 14.8169C4.44827 14.1468 4.00868 13.3839 3.71037 12.5625L2.53713 12.9894C2.88501 13.948 3.39789 14.8383 4.05256 15.6201L5.00931 14.8169Z",
    fill: "#BB4D00"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7896 7.4375C18.0923 8.25801 18.2482 9.12543 18.25 10H19.5C19.4979 8.97979 19.3161 7.96793 18.9629 7.01081L17.7896 7.4375Z",
    fill: "#BB4D00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44887 17.3791C8.5879 17.228 7.76034 16.9262 7.00425 16.4875L6.37994 17.5688C7.26204 18.0805 8.22753 18.4326 9.232 18.6087L9.44887 17.3791Z",
    fill: "#BB4D00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44887 2.62087C10.3088 2.45971 11.1912 2.45971 12.0511 2.62087L12.268 1.391C11.2647 1.203 10.2353 1.203 9.232 1.391L9.44887 2.62087Z",
    fill: "#BB4D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnattended);
export default __webpack_public_path__ + "static/media/ic-unattended.138681e83072ca2dc1ad25209ee246b0.svg";
export { ForwardRef as ReactComponent };